import { fromJS } from 'immutable';
import * as types from '../constants';
/**
 * Introdurre come stato iniziale l'ultima fase disponibile della competition
 */

const initialState = fromJS({
  locations: {},
});

export default function internalRouterReducer(state = initialState, action) {
  switch (action.type) {
    case types.SET_ROUTE:
      return state.mergeIn(['locations'], { [action.widgetId]: fromJS(action.location) });
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/internalRouter.js